module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1743752"
    }
  }, [_c('b', [_vm._v("APPLE AND PARSNIP SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1744252"
    }
  }, [_c('b', [_c('i', [_vm._v("This creamy soup takes delicious advantage of autumn’s bounty. The puree is light, yet rich and flavorful with no need for cream.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1745552"
    }
  }, [_c('b', [_vm._v("Prep: 15 minutes Cook: 20 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1746052"
    }
  }, [_vm._v("1 package (32 ounces) chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1746352"
    }
  }, [_vm._v("2 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1746952"
    }
  }, [_vm._v("1 tablespoon olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1747252"
    }
  }, [_vm._v("2 large shallots, finely chopped (½ cup)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1748452"
    }
  }, [_vm._v("1 stalk celery, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1748752"
    }
  }, [_vm._v("2 pounds McIntosh or Braeburn apples (4 to 6 medium), "), _c('br'), _vm._v(" peeled, cored, and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1749952"
    }
  }, [_vm._v("1 pound parsnips, peeled and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1750252"
    }
  }, [_vm._v("¼ teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1751252"
    }
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1752152"
    }
  }, [_vm._v("¼ teaspoon pepper "), _c('br'), _vm._v(" roasted, hulled pumpkin seeds for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1753652"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In covered 2-quart saucepan, heat chicken broth and water to boiling over high heat.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1754652"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Meanwhile, in 5- to 6-quart saucepot, heat oil over medium heat. Add shallots and celery, and cook about 5 minutes or until softened and lightly browned. Add apples, parsnips, thyme, salt, and ground black pepper, and cook 1 minute.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1757252"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Add hot broth mixture to saucepot; cover and heat to boiling over high heat. Reduce heat to low and simmer, covered, 6 to 7 minutes or until parsnips are very tender.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1759252"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Spoon one-third of apple mixture into blender; cover, removing center part of lid to let steam escape. Lay a paper towel over top and puree until smooth. Pour puree into bowl. Repeat with remaining mixture. Return to saucepot to reheat. Garnish with pumpkin seeds to serve. Makes about 9 cups or 6 appetizer servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1762352"
    }
  }, [_vm._v("Each serving: About 160 calories, 3g protein, 34g carbohydrate, 3g total fat (0g saturated), 6g fiber, 0mg cholesterol, 600mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1765452"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("Tip:")])]), _vm._v(" If you have an immersion blender, use it to puree soup right in the pot.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-685a153f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c46_r1.vue
// module id = 204
// module chunks = 0